import { useContext, useEffect, useState } from "react";
import { Logo, StepProgress, SelectCard, GoBack } from "@cocunat/ui-components";
import HeaderQuizz from "./components/HeaderQuizz";
import { MainContext } from "../../context/main";
import { useNavigate, useParams } from "react-router-dom";
import { QuizzParams } from "../../types";
import { QUIZZ } from "../../constants";

function prefetchWebsite(url: string) {
  let l = document.createElement("link");
  l.rel = "prefetch";
  l.as = "document";
  l.href = url;
  document.head.appendChild(l);
}

function Quizz() {
  const { lang, country, step } = useParams() as QuizzParams;
  const { responses, setResponses } = useContext(MainContext);
  const [redirectTo, setRedirectTo] = useState<string>("");
  const [selected, setSelected] = useState<number>(0);
  const [options, setOptions] = useState<any[]>([]);
  const [question, setQuestion] = useState<string>("");
  let navigate = useNavigate();
  const redirectPath = `https://club.cocunat.com/${lang}-${country}/products`;

  useEffect(() => {
    prefetchWebsite(redirectPath);
  }, []);

  useEffect(() => {
    const currentStep = currentStepResponse(responses);
    console.log(`current step: ${currentStep}`);
    if (currentStep < parseInt(step)) {
      console.log("Aqui 1");
      navigate(`/${lang}-${country}/quizz/${currentStep}/`, { replace: true });
    } else if (Object.keys(QUIZZ).length < currentStep) {
      console.log("Aqui 2");
      navigate(
        `/${lang}-${country}/quizz/${
          Object.keys(QUIZZ)[Object.keys(QUIZZ).length - 1]
        }/`,
        { replace: true }
      );
    } else {
      console.log("Aqui 3");
      setOptions(QUIZZ[step].answers);
      setQuestion(QUIZZ[step].question);
    }
  }, [responses, step]);

  const currentStepResponse = (responses: Array<Object>) => {
    let result = 0;
    for (let key in responses) {
      if (responses[key] === null) {
        return parseInt(key);
      }
      result = parseInt(key);
    }
    return result;
  };

  const updateAnswer = (answer: Object) => {
    if (step) {
      const newResponses = { ...responses };
      newResponses[step] = answer;
      setResponses(newResponses);
      nextStep();
    }
  };

  const nextStep = () => {
    const currentStep = currentStepResponse(responses);
    console.log(`/${lang}-${country}/quizz/${parseInt(step) + 1}/`);
    if (
      Object.keys(QUIZZ).length > currentStep ||
      parseInt(step) < Object.keys(QUIZZ).length
    ) {
      navigate(`/${lang}-${country}/quizz/${parseInt(step) + 1}/`, {
        replace: true,
      });
    } else {
      navigate(`/${lang}-${country}/leads/`, { replace: true });
    }
  };

  const goBack = () => {
    if (step === "1") {
      navigate(`/${lang}-${country}/`, { replace: true });
    } else {
      navigate(`/${lang}-${country}/quizz/${parseInt(step) - 1}/`, {
        replace: true,
      });
    }
  };

  return (
    <div className="quizz-page">
      <section className="container-small">
        <HeaderQuizz />
        {step !== "1" && (
          <div className="go-back">
            <GoBack onClick={goBack} />
          </div>
        )}
        <p style={{ textAlign: "center", color: "#6F6F6F" }}>
          {step} de {Object.keys(QUIZZ).length}
        </p>
        <StepProgress
          current={parseInt(step)}
          steps={Object.keys(QUIZZ).length}
          style={{ justifyContent: "center" }}
        />
        <p style={{ textAlign: "center", marginTop: 24 }}>
          ¡En solo 30 segundos desbloquearás la oferta y nuestras asesoras te
          conocerán!
        </p>
        <h2 style={{ fontSize: 18, marginTop: 32 }}>{question}</h2>
        <SelectCard
          selected={selected}
          onChange={updateAnswer}
          options={options}
        />
      </section>
    </div>
  );
}

export default Quizz;
